import { SEARCH_INPUT_DEFAULTS } from '@constants/ticketMgmt/manage-assignees/searchTypes';
import { history } from '@store/appStore';

export const adjustSearchInputsDefaultValues = () => {
    const { state } = history?.location || {};

    const { prop, value } = state || {}; // Use optional chaining to handle null/undefined

    return {
        ...SEARCH_INPUT_DEFAULTS,
        ...(value ? { [ prop ]: value } : { })
    };
};
